import React from "react";
import { Skeleton } from "antd";
import { Row, Col } from "reactstrap";

const OrderDetailsSkeleton = ({ isQuote = false }) => {
    return (
        <div className="order-details-skeleton" style={{ padding: "20px" }}>
            {/* Header section skeleton */}
            <Row className="mb-4 gy-4">
                {isQuote ? (
                    <>
                        <Col md={6}>
                            <div className="p-4 bg-white rounded shadow-sm border h-100">
                                <Skeleton active paragraph={{ rows: 4 }} title={{ width: 150 }} />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="p-4 bg-white rounded shadow-sm border h-100">
                                <Skeleton active paragraph={{ rows: 4 }} title={{ width: 150 }} />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="p-4 bg-white rounded shadow-sm border h-100">
                                <Skeleton active paragraph={{ rows: 4 }} title={{ width: 150 }} />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="p-4 bg-white rounded shadow-sm border h-100">
                                <Skeleton active paragraph={{ rows: 4 }} title={{ width: 150 }} />
                            </div>
                        </Col>
                    </>
                ) : (
                    <>
                        {[1, 2, 3, 4].map((item) => (
                            <Col md={3} sm={6} key={item}>
                                <div className="p-4 bg-white rounded shadow-sm border h-100">
                                    <Skeleton active paragraph={{ rows: 4 }} title={{ width: 100 }} />
                                </div>
                            </Col>
                        ))}
                    </>
                )}
            </Row>

            {/* Items table/cards skeleton */}
            <Row className="mb-4">
                <Col md={12}>
                    <div className="p-4 bg-white rounded shadow-sm border">
                        <Skeleton.Button active size="large" style={{ width: 150, marginBottom: '20px' }} />
                        <Skeleton active paragraph={{ rows: 4 }} title={false} />
                    </div>
                </Col>
            </Row>

            {/* Bottom section (Notes & Total) */}
            <Row className="mb-4 gy-4">
                <Col md={8} sm={12}>
                    <div className="p-4 bg-white rounded shadow-sm border h-100">
                        <Skeleton active paragraph={{ rows: 6 }} title={{ width: 200 }} />
                    </div>
                </Col>
                <Col md={4} sm={12}>
                    <div className="p-4 bg-white rounded shadow-sm border h-100">
                        <Skeleton active paragraph={{ rows: 6 }} title={{ width: 150 }} />
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default OrderDetailsSkeleton;
